<mat-card>
	<mat-card-title id="PAY_CATEGORY_SETTINGS_TITLE">Settings</mat-card-title>
	<hr />
	<mat-card-content class="card-content" fxLayoutGap="5px">
		<div fxFlex.gt-sm="70%" fxFlex="100">
			<p>
				<span>
					<mat-checkbox
						name="noteexport"
						id="PAY_CATEGORY_EXPORT_TO_WORKDAY_TOGGLE"
						[disabled]="isArchived"
						[(ngModel)]="payCategory.exportToWorkday"
						(ngModelChange)="onExportToWorkdayChange(); isNeedChange()"
					>
						Export to Workday
					</mat-checkbox>
				</span>
			</p>
			<div
				*ngIf="payCategory.exportToWorkday || payCategory.isFlightTime"
				fxLayout="row"
				fxLayoutAlign="start center"
				class="mb-2"
			>
				<mat-form-field position="end" class="ml-xs mr-xs">
					<mat-select
						name="workday"
						required
						placeholder="Workday pay code"
						id="PAY_CATEGORY_WORKDAY_PAY_CODE"
						[disabled]="isArchived"
						[(ngModel)]="payCategory.workdayPayCode"
						(ngModelChange)="isNeedChange()"
					>
						<mat-option *ngFor="let item of payWorkdayCategory" [value]="item">
							{{ item }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
			<div
				*ngIf="payCategory.exportToWorkday || payCategory.isFlightTime"
				fxLayout="row"
				fxLayoutAlign="start center"
				class="mb-2"
			>
				<mat-form-field position="end" class="ml-xs mr-xs">
					<input
						name="factoramount"
						matInput
						required
						type="number"
						pattern="^[1-9][0-9]*$"
						id="PAY_CATEGORY_FACTOR_AMOUNT"
						[disabled]="isArchived"
						[(ngModel)]="payCategory.factorAmount"
						(ngModelChange)="isNeedChange()"
						placeholder="Factor Percentage"
						#factorAmount="ngModel"
					/>
					<mat-error *ngIf="factorAmount?.errors?.pattern"
						>Factor Percentage must be greater than 0</mat-error
					>
				</mat-form-field>
			</div>
			<p>
				<span>
					<mat-checkbox
						name="availability"
						[disabled]="isArchived"
						[(ngModel)]="payCategory.isAvailability"
						(ngModelChange)="isNeedChange()"
					>
						Availability
					</mat-checkbox>
				</span>
			</p>
			<p>
				<span>
					<mat-checkbox
						name="instructionGiven"
						[disabled]="isArchived"
						[(ngModel)]="payCategory.isInstructionGiven"
						(ngModelChange)="isNeedChange()"
					>
						Instruction Given
					</mat-checkbox>
				</span>
			</p>
			<p>
				<span>
					<mat-checkbox
						name="flatRateInstruction"
						[disabled]="isArchived"
						[(ngModel)]="payCategory.isFlatRateInstruction"
						(ngModelChange)="isNeedChange()"
					>
						Flat Rate Instruction
					</mat-checkbox>
				</span>
			</p>
			<p>
				<span>
					<mat-checkbox
						name="incentive"
						[disabled]="isArchived"
						[(ngModel)]="payCategory.isIncentive"
						(ngModelChange)="isNeedChange()"
					>
						Incentive
					</mat-checkbox>
				</span>
			</p>
			<p>
				<span>
					<mat-checkbox
						name="ApHours"
						[disabled]="isArchived"
						[(ngModel)]="payCategory.isApHours"
						(ngModelChange)="isNeedChange()"
					>
						A&P Hours
					</mat-checkbox>
				</span>
			</p>
			<div *ngIf="payCategory.isApHours" fxLayout="row" fxLayoutAlign="start center" class="mb-2">
				<mat-form-field position="end" class="ml-xs mr-xs">
					<input
						name="flathourlyrate"
						matInput
						type="text"
						id="PAY_CATEGORY_FLAT_HOURLY_RATE"
						decimalOnly="twoDigitDecimalNumber"
						[disabled]="isArchived"
						[(ngModel)]="payCategory.flatHourlyRate"
						(ngModelChange)="isNeedChange()"
						placeholder="Flat Hourly Rate"
					/>
				</mat-form-field>
			</div>
			<p>
				<span>
					<mat-checkbox
						name="FlightTime"
						[disabled]="isArchived"
						[(ngModel)]="payCategory.isFlightTime"
						(ngModelChange)="onFlightTimeChange(payCategory.isFlightTime); isNeedChange()"
					>
						Flight Time
					</mat-checkbox>
				</span>
			</p>
			<p>
				<span>
					<mat-checkbox
						name="IsVisibleToLoadSpecialists"
						[disabled]="isArchived"
						[(ngModel)]="payCategory.isVisibleToLoadSpecialists"
						(ngModelChange)="isNeedChange()"
					>
						Visible to Load Specialists
					</mat-checkbox>
				</span>
			</p>
			<div fxLayout="row" fxLayoutAlign="start center">
				<div>&nbsp;</div>
			</div>
		</div>
		<div fxFlex.gt-sm="30%" fxFlex="100" class="display-color">
			<p>Display</p>
			<div fxLayout="row" fxLayoutAlign="start center" class="mb-2">
				<span class="mr-1">Icon</span>
				<button
					id="PAY_CATEGORY_ICON"
					type="button"
					[disabled]="isArchived"
					[style.background]="payCategory.colorName"
					mat-icon-button
					(click)="openIconDialog()"
				>
					<i class="fa-1-5x fa {{ payCategory.iconName }}"></i>
				</button>
			</div>
			<div fxLayout="row" fxLayoutAlign="start center" class="mb-2 display-color-background">
				<span>Color</span>&nbsp;
				<mat-form-field position="end" class="ml-xs mr-xs hover-icon">
					<input
						name="colorName"
						matInput
						id="PAY_CATEGORY_COLOR"
						class="pointer"
						[disabled]="isArchived"
						[colorPicker]="payCategory.colorName"
						[cpPosition]="'left'"
						(ngModelChange)="isNeedChange()"
						(colorPickerChange)="isNeedChange(); payCategory.colorName = $event"
						[style.background]="payCategory.colorName"
					/>
				</mat-form-field>
			</div>
		</div>
	</mat-card-content>
</mat-card>
